// src/hooks/useIsTablet.js
//
// A tablet gets everything the desktop layout has -- same sidebar
// navigation, same full-featured pages, nothing hidden the way things
// are on the mobile layout -- just sized down to fit a narrower screen
// than a typical desktop monitor. This is a genuinely separate range
// from useIsMobile's <768px cutoff: anything from 768px up to 1024px
// (the width most tablets, in portrait or landscape, actually fall
// into) counts as tablet; 1024px and up is a regular desktop-width
// screen. A tablet in landscape at 1024px+ (e.g. a 12.9" iPad) is wide
// enough that the regular desktop sizing already fits it comfortably,
// so it's intentionally treated as desktop, not tablet, past that point.
import { useState, useEffect } from 'react';

const TABLET_MIN = 768;
const TABLET_MAX = 1024;

function computeIsTablet() {
  if (typeof window === 'undefined') return false;
  const w = window.innerWidth;
  return w >= TABLET_MIN && w <= TABLET_MAX;
}

export default function useIsTablet() {
  const [isTablet, setIsTablet] = useState(computeIsTablet);

  useEffect(() => {
    const handleResize = () => setIsTablet(computeIsTablet());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isTablet;
}
